import CropFreeIcon from '@mui/icons-material/CropFree';
import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';

interface ScanButtonProps {
    translations: Record<string, string>;
    isRescan?: boolean;
}

export const ScanButton: React.FC<ScanButtonProps> = ({ translations, isRescan = false }) => (
    <Button
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        startIcon={<CropFreeIcon style={{ fontSize: '1rem' }} />}
        to="/scan"
        component={Link}
    >
        {isRescan ? translations.ACCESS_POINT_RESCAN_BUTTON : translations.GLOBAL_SCAN_BUTTON}
    </Button>
);
